export default __webpack_public_path__ + "static/logo-ba68c497ffd339bb92a7ecee6c5e2c99.png";